import React, { useState } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { axInst } from "../Login/Service";
import { setFilter, clearFilter } from "../../store/slices/FilterSlicePvin";

const dropdownConfigs = [
  { id: "dropdown0", label: "Account Name", filter_status: "Account_Name" },
  { id: "dropdown1", label: "ARN", filter_status: "Accnt_Arn" },
  // { id: "dropdown6", label: "Dealer Code", filter_status: "Dealer_Code" },
  { id: "dropdown2", label: "Contact No", filter_status: "Contact_Number" },
  { id: "dropdown3", label: "Ka code", filter_status: "Ka_code" },
  { id: "dropdown4", label: "Asset No", filter_status: "Asset_Number" },
  {
    id: "dropdown5",
    label: "Vehicle Reg",
    filter_status: "Vechile_Registeration_No",
  },
];

const fetchDropdownData = async (filter_status) => {
  const res = await axInst.post("/pvin/filter", { filter_status });
  return res.data; // [{ key: "...", doc_count: ... }]
};

const PvinFilter = () => {
  const dispatch = useDispatch();
  const [selectedDropdown, setSelectedDropdown] = useState(null);
  const [selectedValues, setSelectedValues] = useState({});

  const handleChange = (dropdownId, option) => {
    setSelectedValues((prev) => ({ ...prev, [dropdownId]: option }));

    if (option === null) {
      // user cleared selection → enable all dropdowns
      setSelectedDropdown(null);
    } else {
      setSelectedDropdown(dropdownId);
    }
  };

  const handleSearch = () => {
    if (!selectedDropdown || !selectedValues[selectedDropdown]) return;

    const selectedConfig = dropdownConfigs.find(
      (d) => d.id === selectedDropdown,
    );

    const payload = {
      [selectedConfig.filter_status]: [selectedValues[selectedDropdown]?.value],
    };

    dispatch(setFilter(payload));
  };

  const handleReset = () => {
    setSelectedDropdown(null);
    setSelectedValues({});
    dispatch(clearFilter());
  };

  // ✅ Fetch all dropdown data on page load
  const dropdown0 = useQuery({
    queryKey: ["dropdownData", "Account_Name"],
    queryFn: () => fetchDropdownData("Account_Name"),
    staleTime: Infinity,
  });

  const dropdown1 = useQuery({
    queryKey: ["dropdownData", "Par_Accnt_Arn"],
    queryFn: () => fetchDropdownData("Par_Accnt_Arn"),
    staleTime: Infinity,
  });

  const dropdown2 = useQuery({
    queryKey: ["dropdownData", "Contact_Number"],
    queryFn: () => fetchDropdownData("Contact_Number"),
    staleTime: Infinity,
  });

  const dropdown3 = useQuery({
    queryKey: ["dropdownData", "Ka_code"],
    queryFn: () => fetchDropdownData("Ka_code"),
    staleTime: Infinity,
  });

  const dropdown4 = useQuery({
    queryKey: ["dropdownData", "Asset_Number"],
    queryFn: () => fetchDropdownData("Asset_Number"),
    staleTime: Infinity,
  });

  const dropdown5 = useQuery({
    queryKey: ["dropdownData", "Vechile_Registeration_No"],
    queryFn: () => fetchDropdownData("Vechile_Registeration_No"),
    staleTime: Infinity,
  });
  // const dropdown6 = useQuery({
  //   queryKey: ["dropdownData", "Dealer_Code"],
  //   queryFn: () => fetchDropdownData("Dealer_Code"),
  //   staleTime: Infinity,
  // });

  const queries = [
    dropdown0,
    dropdown1,
    // dropdown6,
    dropdown2,
    dropdown3,
    dropdown4,
    dropdown5,
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-7 gap-1 p-2 mt-2 border-[#2c8a8b] border rounded-md">
      {dropdownConfigs.map((dropdown, index) => {
        const { data, isLoading } = queries[index];
        const options = data?.map((item) => ({
          value: item.key,
          label: item.key,
        }));

        return (
          <div key={dropdown.id} className="flex flex-col gap-1">
            {/* Label above dropdown */}
            <label className="text-[11px] font-semibold text-gray-600">
              {dropdown.label}
            </label>

            <Select
              options={options || []}
              value={selectedValues[dropdown.id] || null}
              onChange={(option) => handleChange(dropdown.id, option)}
              isDisabled={selectedDropdown && selectedDropdown !== dropdown.id}
              isClearable
              placeholder="Select"
              classNamePrefix="react-select"
              isLoading={isLoading}
              styles={{
                placeholder: (base) => ({
                  ...base,
                  fontSize: "12px",
                  color: "#999",
                }),
                singleValue: (base) => ({
                  ...base,
                  fontSize: "12px",
                }),
                option: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  padding: "6px 10px",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                  color: state.isSelected ? "#000" : "#333",
                }),
                control: (base) => ({
                  ...base,
                  minHeight: "32px",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
        );
      })}

      <div className="flex  items-end gap-2">
        <button
          onClick={handleSearch}
          disabled={!selectedDropdown || !selectedValues[selectedDropdown]}
          className={`px-4 py-2 rounded-md text-white font-semibold text-sm ${
            selectedDropdown && selectedValues[selectedDropdown]
              ? "bg-[#2A5775] hover:bg-[#466e89]"
              : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          Search
        </button>

        <button
          onClick={handleReset}
          className="px-4 py-2 rounded-md bg-gray-200 text-sm hover:bg-gray-300"
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default PvinFilter;
